import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { ApiExplorerPageWithUrlSync } from '../../components/catalog/ApiExplorerPageWithUrlSync';

export const apiDocsPluginFrontendOverride = apiDocsPlugin.withOverrides({
  extensions: [
    apiDocsPlugin.getExtension('page:api-docs').override({
      params: {
        path: '/api-docs',
        noHeader: true,
        loader: async () => <ApiExplorerPageWithUrlSync />,
      },
    }),
  ],
});